import React, { useContext, useState } from "react";
import { Context } from "../../context/Context";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Login = ({ setShowLogin }) => {
  const { setToken, url } = useContext(Context);
  const [data, setData] = useState({
    email: "",
    haslo: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showResetForm, setShowResetForm] = useState(false); // New state for reset form
  const [resetEmail, setResetEmail] = useState(""); // New state for reset email
  const [resetMessage, setResetMessage] = useState(""); // New state for reset message
  const [resetLoading, setResetLoading] = useState(false); // New state for reset loading

  const navigate = useNavigate();
  const onChangeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setData((data) => ({ ...data, [name]: value }));
  };

  const onLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true

    const new_url = `${url}/api/user/login`; // Use the url from context

    try {
      const response = await axios.post(new_url, data);
      if (response.data.success) {
        setToken(response.data.token);
        localStorage.setItem("token", response.data.token);
        setShowLogin(false);

        // Redirect based on role
        switch (response.data.role) {
          case "admin":
            navigate("/admin");
            break;
          case "trainer":
            navigate("/trainer");
            break;
          default:
            navigate("/userpanel");
        }
      } else {
        setError(response.data.message || "Login failed. Please try again."); // Set error message
      }
    } catch (error) {
      console.error("Error during login:", error); // Log the error
      if (error.response) {
        // The request was made and the server responded with a status code
        setError(
          `Error: ${error.response.status} - ${
            error.response.data.message ||
            "An error occurred. Please try again."
          }`
        );
      } else if (error.request) {
        // The request was made but no response was received
        setError(
          "No response received from the server. Please check your network connection."
        );
      } else {
        // Something happened in setting up the request that triggered an Error
        setError(
          "An error occurred while setting up the request. Please try again."
        );
      }
    } finally {
      setLoading(false); // Reset loading state
    }
  };
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setResetLoading(true);
    setResetMessage("");

    try {
      const response = await axios.post(`${url}/api/user/reset-password`, {
        email: resetEmail,
      });

      if (response.data.success) {
        setResetMessage(response.data.message);
        setResetEmail("");
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      setError(
        error.response?.data?.message ||
          "Wystąpił błąd podczas resetowania hasła. Spróbuj ponownie."
      );
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#191919] p-10">
      {/* Test Credentials Info Box */}
      <div className="absolute top-4 right-4 bg-blue-900 text-white p-4 rounded-lg shadow-lg max-w-xs">
        <h3 className="font-bold mb-2 text-sm">📋 Dane do testowania:</h3>
        <div className="text-xs space-y-2">
          <div>
            <p className="font-semibold">Admin:</p>
            <p>Email: admin@gym.test</p>
            <p>Hasło: admin1234</p>
          </div>
          <div>
            <p className="font-semibold">Trener:</p>
            <p>Email: trainer1@gym.test</p>
            <p>Hasło: password0</p>
          </div>
          <div>
            <p className="font-semibold">Użytkownik (przykład):</p>
            <p>Email: mateusz.kowalski.2@test.local</p>
            <p>Hasło: password2</p>
          </div>
        </div>
      </div>
      {showResetForm ? (
        <form
          onSubmit={handleResetPassword}
          className="bg-white rounded-lg p-8 w-full max-w-md shadow-xl border border-gray-200"
        >
          <h2 className="text-3xl font-semibold text-gray-800 mb-6 text-center">
            Resetowanie hasła
          </h2>
          {resetMessage && (
            <p className="text-green-500 mb-4">{resetMessage}</p>
          )}
          {error && <p className="text-red-500 mb-4">{error}</p>}
          <div className="space-y-6">
            <input
              name="resetEmail"
              onChange={(e) => setResetEmail(e.target.value)}
              value={resetEmail}
              type="email"
              placeholder="Podaj swój email"
              className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              required
            />
          </div>
          <button
            type="submit"
            className={`w-full mt-6 py-3 text-lg font-semibold rounded-md ${
              resetLoading ? "bg-gray-400" : "bg-orange-600 hover:bg-orange-700"
            } text-white transition duration-300 ease-in-out transform`}
            disabled={resetLoading}
          >
            {resetLoading ? "Wysyłanie..." : "Wyślij nowe hasło"}
          </button>
          <button
            type="button"
            onClick={() => {
              setShowResetForm(false);
              setError("");
              setResetMessage("");
            }}
            className="w-full mt-4 py-3 text-lg font-semibold rounded-md bg-gray-200 hover:bg-gray-300 text-gray-800 transition duration-300 ease-in-out transform"
          >
            Powrót do logowania
          </button>
        </form>
      ) : (
        <form
          onSubmit={onLogin}
          className="bg-white rounded-lg p-8 w-full max-w-md shadow-xl border border-gray-200"
        >
          <h2 className="text-3xl font-semibold text-gray-800 mb-6 text-center">
            Login
          </h2>
          {error && <p className="text-red-500 mb-4">{error}</p>}
          <div className="space-y-6">
            <input
              name="email"
              onChange={onChangeHandler}
              value={data.email}
              type="email"
              placeholder="Email"
              className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              required
            />
            <input
              name="haslo"
              onChange={onChangeHandler}
              value={data.haslo}
              type="password"
              placeholder="Hasło"
              className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              required
            />
          </div>
          <button
            type="submit"
            className={`w-full mt-6 py-3 text-lg font-semibold rounded-md ${
              loading ? "bg-gray-400" : "bg-orange-600 hover:bg-orange-700"
            } text-white transition duration-300 ease-in-out transform`}
            disabled={loading}
          >
            {loading ? "Logowanie..." : "Zaloguj"}
          </button>
          <button
            type="button"
            onClick={() => setShowResetForm(true)}
            className="w-full mt-4 py-3 text-lg font-semibold rounded-md bg-gray-200 hover:bg-gray-300 text-gray-800 transition duration-300 ease-in-out transform"
          >
            Zapomniałeś hasła?
          </button>
        </form>
      )}
    </div>
  );
};

export default Login;
